var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLeaderboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.126 13.8L3 17L5.5 18.5L7 21L10.899 16.905",
    stroke: "#F6F1F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1011 16.905L17.0001 21L18.5001 18.5L21.0001 17L17.8741 13.8",
    stroke: "#F6F1F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9497 5.05025C19.6834 7.78392 19.6834 12.2161 16.9497 14.9497C14.2161 17.6834 9.78392 17.6834 7.05025 14.9497C4.31658 12.2161 4.31658 7.78392 7.05025 5.05025C9.78392 2.31658 14.2161 2.31658 16.9497 5.05025",
    stroke: "#F6F1F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9989 12.584L13.7959 13.528C14.1459 13.712 14.5549 13.415 14.4879 13.025L14.1449 11.024L15.5989 9.60804C15.8819 9.33204 15.7259 8.85104 15.3349 8.79404L13.3259 8.50204L12.4279 6.68104C12.2529 6.32604 11.7479 6.32604 11.5729 6.68104L10.6749 8.50204L8.66491 8.79504C8.27391 8.85204 8.11791 9.33305 8.40091 9.60905L9.85491 11.025L9.51191 13.026C9.44491 13.416 9.85391 13.713 10.2039 13.529L12.0009 12.585H11.9989V12.584Z",
    stroke: "#F6F1F2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeaderboard);
export default __webpack_public_path__ + "static/media/icon-leaderboard.92ec8f72db692f86fdfe66e89a86db28.svg";
export { ForwardRef as ReactComponent };